<template>
  <div>
    <custom-crud-list ref="crudList" v-bind="listConfiguration">
      <template #cell-createdAt="{ item }">
        <span class="ltr created-at-cell-content inline-block">
          {{ translateDate(item.createdAt, "dateWithTime") }}
        </span>
      </template>
      <template #cell-userGroups="{ item }">
        <span class="flex gap-xs flex-wrap">
          <badge v-for="group in item.UserGroups" :auto-translate="false">
            {{ tu(group.name) }}
          </badge>
        </span>
      </template>
      <template #cell-data="{ item }">
        <div>
          <user-task-item
            :key="`task-data-key-${item.id}`"
            :id="`task-data-${item.id}`"
            @userTask:taskHandingComplete="handleTaskCompleted"
            layout="data"
            :task="item"></user-task-item>
        </div>
      </template>
      <template #cell-dueDateTime="{ item }">
        <span>
          <span class="force-ltr" v-if="item.dueDateTime">
            {{ translateDate(item.dueDateTime, "dateWithTime") }}
          </span>
          <span v-else>-</span>
        </span>
      </template>
      <template #cell-taskType="{ item }">
        <span>
          {{ tu(`userTasks.types.${item.taskType}.label`) }}
        </span>
      </template>
      <template #cell-isComplete="{ item }">
        <span
          v-if="
            item.isComplete === 1 ||
            item.isComplete === true ||
            item.isComplete === 'true'
          "
          ><icon icon="check" theme="success"
        /></span>
        <span v-else><icon icon="x" theme="error" /></span>
      </template>

      <template #cell-actions-extra-before="{ item, index, crudList }">
        <user-task-item
          :key="`task-actionMicro-key-${item.id}`"
          :id="`task-actionMicro-${item.id}`"
          @userTask:taskHandingComplete="handleTaskCompleted"
          layout="actionMicro"
          :task="item"></user-task-item>
      </template>
    </custom-crud-list>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import CustomCrudList from "@/client/components/crud/customV1/List.vue";
import { computed } from "vue";

export default {
  components: { CustomCrudList },
  middleware: {
    requireSuperAdmin: {},
  },
  props: {},
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  data: function () {
    let groups = this.$acl.getUserGroupIds();

    if (!groups) {
      groups = [];
    }

    return {
      listConfiguration: {
        noItemsFoundText: "userTasks.list.noItems",
        subject: "userTask",
        listSrc: "entity/userTask",
        initialOrdering: { key: "dueDateTime", direction: "desc" },
        showIdField: true, // bool deafult true
        sortable: false, //bool, default false
        publishable: false, //bool, default false
        enableMassActions: true,
        editRoutePrefix: false,
        editRoute: false,
        createRoute: false,
        deleteRoute: "entity/userTask",
        additionalListData: {
          simplified: false,
          translate: true,
        },
        initialFilters: {
          userGroups: groups,
          isComplete: false,
        },
        fields: {
          // these are the table columns
          createdAt: {
            itemKey: "createdAt",
            label: "userTasks.fields.createdAt",
          },
          createdFrom: {
            itemKey: "createdFrom",
            label: "userTasks.fields.createdFrom",
            listable: false,
            filterable: {
              name: "createdFrom",
              type: "datePicker",
              placeholder: "userTasks.fields.createdFrom",
            },
            orderable: false,
          },
          createdBefore: {
            itemKey: "createdBefore",
            label: "userTasks.fields.createdBefore",
            listable: false,
            filterable: {
              name: "createdBefore",
              type: "datePicker",
              placeholder: "userTasks.fields.createdBefore",
            },
            orderable: false,
          },
          dueFrom: {
            itemKey: "dueFrom",
            label: "userTasks.fields.dueFrom",
            listable: false,
            filterable: {
              name: "dueFrom",
              type: "datePicker",
              placeholder: "userTasks.fields.dueFrom",
            },
            orderable: false,
          },
          dueBefore: {
            itemKey: "dueBefore",
            label: "userTasks.fields.dueBefore",
            listable: false,
            filterable: {
              name: "dueBefore",
              type: "datePicker",
              placeholder: "userTasks.fields.dueBefore",
            },
            orderable: false,
          },
          dueDateTime: {
            itemKey: "dueDateTime",
            label: "userTasks.fields.dueDateTime",
            listable: true,
            orderable: true,
          },
          taskType: {
            itemKey: "taskType",
            label: "userTasks.fields.taskType",
            listable: true,
          },
          data: {
            itemKey: "dueBefore",
            label: "userTasks.fields.data",
            filterable: false,
            orderable: false,
            listable: true,
          },
          isComplete: {
            itemKey: "isComplete",
            label: "userTasks.fields.isComplete",
            quickEdit: computed(() => {
              if (this.$acl.can("userTask", "update", "isComplete")) {
                return {
                  type: "binaryInteger",
                };
              }

              return false;
            }),
            filterable: {
              name: "isComplete",
              type: "select2",
              placeholder: "userTasks.fields.isComplete",
              translateList: true,
              list: [
                { value: null, label: "core.all" },
                { value: 0, label: "core.no" },
                { value: 1, label: "core.yes" },
              ],
            },
            orderable: true,
          },
          userGroups: {
            itemKey: "userGroups",
            label: "userTasks.fields.userGroups",

            orderable: false,
            filterable: computed(() => {
              if (this.$acl.isSuperAdmin) {
                return {
                  type: "Select2",
                  asyncListSource: "entity/userGroup",
                  asyncDataTextFilterParamName: "title",
                  textFilterAsSaffronListFilter: true,
                  multiple: true,
                  asyncListData: {
                    simplified: true,
                  },
                };
              } else {
                return false;
              }
            }),
          },
        },
        actions: {
          show: false,
          edit: false,
          delete: computed(() => this.$acl.can("userTask", "delete")),
          create: false,
        },
        massActions: {
          delete: computed(() => this.$acl.can("userTask", "delete")),
          custom: {},
        },
      },
      asyncData: {},
    };
  },
  computed: {},
  methods: {
    handleTaskCompleted() {
      this.$refs["crudList"].reloadItems();
    },
    logStarted(data) {
      console.log("super parent - got started", data);
    },
    logComplete(data) {
      console.log("super parent - got complete", data);
    },
  },
};
</script>
